/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpuResVo } from './SpuResVo';
import {
    SpuResVoFromJSON,
    SpuResVoFromJSONTyped,
    SpuResVoToJSON,
    SpuResVoToJSONTyped,
} from './SpuResVo';

/**
 * 
 * @export
 * @interface ResponseSpuResVo
 */
export interface ResponseSpuResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSpuResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSpuResVo
     */
    message?: string;
    /**
     * 
     * @type {SpuResVo}
     * @memberof ResponseSpuResVo
     */
    data?: SpuResVo;
}

/**
 * Check if a given object implements the ResponseSpuResVo interface.
 */
export function instanceOfResponseSpuResVo(value: object): value is ResponseSpuResVo {
    return true;
}

export function ResponseSpuResVoFromJSON(json: any): ResponseSpuResVo {
    return ResponseSpuResVoFromJSONTyped(json, false);
}

export function ResponseSpuResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSpuResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SpuResVoFromJSON(json['data']),
    };
}

export function ResponseSpuResVoToJSON(json: any): ResponseSpuResVo {
    return ResponseSpuResVoToJSONTyped(json, false);
}

export function ResponseSpuResVoToJSONTyped(value?: ResponseSpuResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SpuResVoToJSON(value['data']),
    };
}

